import type { Lesson } from "@/core/types";
import { formelAufgabe } from "../formelaufgabe";

export const lektionIndexVergleich: Lesson = {
  id: "index-vergleich",
  title: "INDEX und VERGLEICH",
  summary: "Das Nachschlage-Duo, das in jeder Excel-Version funktioniert – auch nach links.",
  durationMinutes: 10,
  learningGoals: [
    "Mit VERGLEICH die Position eines Werts bestimmen",
    "Mit INDEX den Wert an einer Position holen",
    "Beide zu einem Nachschlagen in beliebiger Richtung kombinieren",
  ],
  steps: [
    {
      id: "zwei-funktionen",
      title: "Zwei Funktionen, eine Aufgabe",
      explanation: [
        "VERGLEICH(Suchwert;Bereich;0) liefert, an welcher Stelle ein Wert in einer Spalte " +
          "steht – die 0 verlangt eine genaue Übereinstimmung. INDEX(Bereich;Zeile) liefert " +
          "den Wert an einer Stelle. Zusammen: =INDEX(C:C;VERGLEICH(F2;A:A;0)) sucht F2 in " +
          "Spalte A und holt den Wert aus derselben Zeile in Spalte C.",
        "Anders als SVERWEIS ist die Rückgabespalte frei wählbar – auch links von der " +
          "Suchspalte – und das Einfügen einer Spalte zerlegt die Formel nicht, weil keine " +
          "Spaltennummer abgezählt wird.",
        "In Microsoft 365 erledigt XVERWEIS dasselbe in einer Funktion (siehe Modul " +
          "„Funktionen“). INDEX/VERGLEICH bleibt wichtig, weil es in jeder Excel-Version " +
          "läuft und in vielen bestehenden Mappen steckt. Mit zwei VERGLEICH-Funktionen – " +
          "eine für die Zeile, eine für die Spalte – wird daraus sogar ein Nachschlagen in " +
          "einer Kreuztabelle.",
      ],
      keyPoints: [
        "=INDEX(Rückgabespalte;VERGLEICH(Suchwert;Suchspalte;0)).",
        "Die 0 in VERGLEICH = genaue Übereinstimmung.",
        "Funktioniert nach links und übersteht eingefügte Spalten.",
      ],
      task: {
        instruction:
          "Schlage mit INDEX und VERGLEICH in einer Formel einen Wert nach – zum Beispiel " +
          "den Preis zu einer Artikelnummer.",
        hint: "=INDEX(C2:C20;VERGLEICH(F2;A2:A20;0))",
        check: formelAufgabe(
          [
            { label: "INDEX", funktionen: ["index"] },
            { label: "VERGLEICH", funktionen: ["vergleich", "xvergleich"] },
          ],
          {
            success: "Nachschlagen ohne abgezählte Spaltennummer – robust und in jeder Version.",
            failure: "Es gibt noch keine Formel, die INDEX und VERGLEICH kombiniert.",
            hint: "#NV bedeutet: Der Suchwert steht nicht in der Suchspalte, oft wegen eines Leerzeichens.",
          },
          true,
        ),
      },
    },
  ],
};
